export const EXPORT = {
    REQUEST: 'Report/Export/Request',
    SUCCESS: 'Report/Export/Success',
    FAILURE: 'Report/Export/Failure'
  };
  